export default __webpack_public_path__ + "static/media/ppoint.90bc53d4.svg";